import React from 'react';
import ReactLoader from 'react-loading';

import { makeStyles } from '@material-ui/styles';
import { useTheme } from 'styled-components';
import { ThemeType } from 'theme/theme';

import Toggle from 'components/Toggle';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { CostCenter } from 'models/costCenter';

import { Container, Content, Header, Switch, ArrowIcon, ToggleLoader, ToggleContainer } from './styles';

interface Props {
  costCenter: CostCenter;
  onClick: () => void;
  onToggle?: () => void;
  loading?: boolean;
}

const CostCenterItem = ({ costCenter, onClick, onToggle, loading }: Props) => {
  const { t } = useStoreTranslation();

  const theme = useTheme() as ThemeType;

  const useStyles = makeStyles(() => ({
    switch_track: {},
    switch_base: {
      color: '#f50057',
      '&.Mui-disabled': {
        color: 'Red',
      },
      '&.Mui-checked': {
        color: 'Pink',
      },
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.secondaryBackgroundColor,
      },
    },
    switch_primary: {
      '&.Mui-checked': {
        color: '#4CAF50',
      },
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#4CAF50',
      },
    },
  }));

  return (
    <Container>
      <Switch>
        <ToggleContainer>
          {loading && (
            <ToggleLoader>
              <ReactLoader type="bubbles" color="#C3C2C2" width={30} height={30} />
            </ToggleLoader>
          )}
          <Toggle
            onChange={onToggle}
            checked={costCenter.isActive}
            classes={{
              track: useStyles().switch_track,
              switchBase: useStyles().switch_base,
              colorPrimary: useStyles().switch_primary,
            }}
            disabled={loading}
          />
        </ToggleContainer>
      </Switch>
      <Content onClick={onClick}>
        <Header>
          <Header.Title>{costCenter.name}</Header.Title>
          <Header.Text>{t('costCenter.costCenterAggregation.code', { code: costCenter.code })}</Header.Text>
        </Header>
        <ArrowIcon />
      </Content>
    </Container>
  );
};

export default CostCenterItem;
